import { configureStore } from '@reduxjs/toolkit'
import quizReducer from './Features/Quiz/quizStateSlice'

export const store = configureStore({
  reducer: {
    quiz: quizReducer,
  },
})
